import interactionParserUtils from '../qti/parser/question/interactions/InteractionParserUtils';
import xmlDomUtils from '../qti/utils/XmlDomUtils';
import settingsReader from '../store/readHelpers/SettingsReader';
import constants from '../qti/Constants';
import sessionReader from '../store/readHelpers/SessionReader';

const feedbackService = {
    hasValidResponseFeedback(identifier, question, feedback, shouldShowFeedback = true) {
        const isFeedbackString = typeof feedback === 'string';
        if ((isFeedbackString && !feedback) || !shouldShowFeedback) {
            return false;
        }
        const feedbackForResponse = isFeedbackString ? [feedback] : feedback?.[identifier];
        const { supportedLanguages, language } = question;

        if (!feedbackForResponse?.length || !feedbackForResponse[0]) {
            return false;
        }

        const element = xmlDomUtils.getElementFromString(feedbackForResponse[0]);
        let languageNode = interactionParserUtils.getLanguageNodeForFeedback(element, language, supportedLanguages);

        if (!languageNode) {
            const childNodesToString = Array.from(element?.childNodes).map(node => xmlDomUtils.stringify(node)).join('').trim();
            languageNode = xmlDomUtils.getElementFromString(`<div>${childNodesToString}</div>`);
        }
        return interactionParserUtils.isNewLanguageSupportFormat(element, supportedLanguages) && this.shouldRenderFeedback(languageNode);
    },
    resolveFeedbackElement(destinationSelector) {
        return document.querySelector(destinationSelector);
    },

    shouldRenderFeedback(languageNode) {
        return Array.from(languageNode.childNodes).some((item) => {
            const { nodeType, nodeValue } = item;

            const shouldRenderElement =
                !(nodeType === Node.ELEMENT_NODE && item.getAttribute('style') === 'display: none;');

            const shouldRenderText = !(nodeType === Node.TEXT_NODE && !nodeValue.replace(/\s+/g, ''));

            return shouldRenderElement && shouldRenderText;
        });
    },

    /**
     * If feedback is in props, it means we are allowed to display the feedback. This is because the filtering of the
     * permitted feedback is done on the server side, thus the frontend can simply use everything it finds.
     * @returns {string}
     */
    getParsedFeedbackForQuestion(modalFeedback, question) {
        const {
            language,
            defaultLanguage,
            templateDeclarations,
            supportedLanguages,
        } = question;

        if (!modalFeedback) {
            return null;
        }

        const element = xmlDomUtils.getElementFromString(modalFeedback);
        const isNewLanguageSupportFormat = interactionParserUtils.isNewLanguageSupportFormat(element, supportedLanguages);
        const languageNode = isNewLanguageSupportFormat && interactionParserUtils.getLanguageNodeForFeedback(
            element,
            language,
            supportedLanguages
        );

        if (languageNode) {
            if (!this.shouldRenderFeedback(languageNode)) return null;

            return interactionParserUtils.replaceVariablesAndSerializeFeedback(
                languageNode,
                templateDeclarations
            );
        }

        // add check for old feedback format
        if (!languageNode && !isNewLanguageSupportFormat) {
            return interactionParserUtils.getNodeContent(
                element,
                language,
                defaultLanguage
            );
        }

        return null;
    },
    showInteractionFeedback(interactionType) {
        const { interactionType: {
            NUMERIC_SIMULATIONS, SYMBOLIC_MATH,
        } } = constants;

        return (
            [NUMERIC_SIMULATIONS, SYMBOLIC_MATH].includes(interactionType)
            && (
                sessionReader.isContextPreview()
                || settingsReader.isInteractionFeedbackEnabled()
            )
        );
    },
    showAlternativeFeedback(type) {
        const { interactionType: {
            CHOICE_INTERACTION, INLINE_CHOICE_INTERACTION,
        } } = constants;
        return [CHOICE_INTERACTION, INLINE_CHOICE_INTERACTION].includes(type);
    },
};

export default feedbackService;
